<template>
  <div class="terms-container">
    <h1 class="terms-title">Terms of Service</h1>

    <section class="terms-section">
      <h2>1. Introduction</h2>
      <p>
        Welcome to YOLEE. By accessing or using our website and services, you
        agree to comply with and be bound by these Terms of Service. If you do
        not agree with these terms, please do not use our services.
      </p>
    </section>

    <section class="terms-section">
      <h2>2. Use of Services</h2>
      <p>
        YOLEE provides trade and sourcing services connecting customers with
        manufacturing partners. You agree to use our services only for lawful
        purposes and in accordance with these terms.
      </p>
    </section>

    <section class="terms-section">
      <h2>3. Intellectual Property</h2>
      <p>
        All content, trademarks, and intellectual property on this website are
        owned or licensed by YOLEE. You may not reproduce, distribute, or create
        derivative works without our prior written consent.
      </p>
    </section>

    <section class="terms-section">
      <h2>4. Disclaimer</h2>
      <p>
        YOLEE acts as a facilitator between customers and manufacturing
        partners. While we strive to provide accurate and up-to-date
        information, we do not guarantee the completeness, accuracy, or
        reliability of any content. Use of our services is at your own risk.
      </p>
    </section>

    <section class="terms-section">
      <h2>5. Limitation of Liability</h2>
      <p>
        YOLEE shall not be liable for any indirect, incidental, or consequential
        damages arising from the use of our services. Our liability is limited
        to the extent permitted by law.
      </p>
    </section>

    <section class="terms-section">
      <h2>6. Privacy</h2>
      <p>
        Our Privacy Policy explains how we collect, use, and protect your
        information. By using our services, you agree to the terms outlined in
        our Privacy Policy.
      </p>
    </section>

    <section class="terms-section">
      <h2>7. Changes to Terms</h2>
      <p>
        YOLEE reserves the right to update or modify these Terms of Service at
        any time. Changes will be effective upon posting on our website.
        Continued use of the services constitutes acceptance of the updated
        terms.
      </p>
    </section>

    <section class="terms-section">
      <h2>8. Governing Law</h2>
      <p>
        These Terms of Service are governed by and construed in accordance with
        the laws of the jurisdiction in which YOLEE operates, without regard to
        its conflict of law principles.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "Terms",
  mounted() {
    this.$emit("set-product-page", true);
  },
  beforeDestroy() {
    this.$emit("set-product-page", false);
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";

.terms-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1rem;
  color: @color-text-content;
  line-height: 1.8;

  h1,
  h2 {
    color: @color-text-title;
    font-family: @font-en;
  }

  .terms-title {
    font: 700 28px/1.3 @font-en;
    margin-bottom: 2rem;
    border-bottom: 2px solid @color-primary;
    padding-bottom: 0.5rem;
  }

  .terms-section {
    margin-bottom: 1.8rem;

    h2 {
      font: 600 20px/1.4 @font-en;
      margin-bottom: 0.5rem;
    }

    p {
      font-size: 16px;
      color: @color-text-content;
    }
  }
}
</style>
